import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import ErrorsWarnings from "../ErrorsWarnings";
import { camelCase, get } from "lodash";
import permissions from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";
import { FILE_UPLOAD_STATUS } from "../../utils";
import { NoteHoverEvent } from "@progress/kendo-react-charts";
import { isEmpty } from "lodash";

const FileStatusPayroll = (props) => {
  const {
    stepperDetails,
    fileStatus,
    errorType,
    setLoading,
    warnings,
    errors,
    duplicatesCount,
    status,
    showTrash,
    // pageRefresh,
    deleteUploadedFileById,
    menu,
    setDeleteSlider,
    columns,
  } = props;
  const [progress, setProgress] = useState();

  useEffect(() => {
    switch (status) {
      case FILE_UPLOAD_STATUS.FileUploadInProgress:
        setProgress([
          {
            count: 1,
            status: "grey",
          },
          {
            count: 2,
            status: "grey",
          },
          {
            count: 3,
            status: "grey",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.ErrorCorrectionRequired:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "blue",
          },
          {
            count: 3,
            status: "grey",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.CreationInProgress:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.StructuralValidationFailed:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "blue",
          },
          {
            count: 3,
            status: "grey",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.SystemFailure:
        setProgress([
          {
            count: 1,
            status: "grey",
          },
          {
            count: 2,
            status: "grey",
          },
          {
            count: 3,
            status: "grey",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.PendingSubmission:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "blue",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.AwaitingFunding:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "blue",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.AwaitingFundConfirmation:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.AwaitingTrade:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.PayrollFunded:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.Completed:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      default:
        setProgress([]);
        break;
    }
  }, [status]);
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };

  const isAllowedDelete = () => {
    return (
      permissions &&
      permissions[roleName][menu + "SubMenu"][camelCase("uploadFile")].includes(
        "D"
      )
    );
  };
  return (
    <>
      {/* <div className="d-flex justify-content-between">
        {fileStatus === FILE_UPLOAD_STATUS.Cancelled ? (
          ""
        ) : fileStatus === FILE_UPLOAD_STATUS.Deleted ? (
          ""
        ) : (
          <div>
            {showTrash
              ? permissions[roleName].menuItems[menu].includes("D") && (
                  <div onClick={onRemove}>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      size="13px"
                      color="#FF0000"
                    />
                  </div>
                )
              : null}
          </div>
        )}
      </div> */}

      <div className={`d-flex gradient${fileStatus}`} style={columns[4].style}>
        <div
          className="ft-12"
          style={{
            display: "flex",
            flexWrap: "wrap",
            width: "276px",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flexStart",
            paddingLeft: "15%",
          }}
        >
          <p
            style={
              fileStatus == FILE_UPLOAD_STATUS.ErrorCorrectionRequired ||
              fileStatus == FILE_UPLOAD_STATUS.DuplicateRecordsFound
                ? { marginTop: "0%" }
                : { marginTop: "8%" }
            }
            className={
              errorType === 2 || errorType === 3
                ? "ft-12 font-weight-500 mb-10 text-black"
                : "ft-12 font-weight-500 mb-10 text-black mt-16"
            }
          >
            {" "}
            {fileStatus === FILE_UPLOAD_STATUS.FileUploadInProgress ? (
              <span className="inprogress-text">File upload in progress</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.ErrorCorrectionRequired ? (
              <span className="error-text fw-600 ft-16">
                Error Corrections required
              </span>
            ) : fileStatus === FILE_UPLOAD_STATUS.StructuralValidationFailed ? (
              <span className="error-text">Error in File Processor</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.SystemFailure ? (
              <span className="error-text mt-1">System Failure</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.PendingSubmission ? (
              <span className="pending-text">Pending Submission</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.AwaitingFunding ? (
              <span className="awaiting-fund-text">Awaiting funding</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.CreationInProgress ? (
              <span className="creation-text">Creation in progress</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.Cancelled ? (
              <span className="cancelled-text">Cancelled</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.Deleted ? (
              <span className="deleted-text">Deleted</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.AwaitingTrade ? (
              <span className="awaiting-trade-text">Awaiting Trade</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.AwaitingFundConfirmation ? (
              <span className="awaiting-fund-confirm-text">
                Awaiting Fund Confirmation
              </span>
            ) : fileStatus === FILE_UPLOAD_STATUS.PayrollFunded ? (
              <span className="payroll-funded-text">Payroll Funded</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.Completed ? (
              <span className="completed-text">Completed</span>
            ) : fileStatus === FILE_UPLOAD_STATUS.PayrollFundingInProgress ? (
              <span className="completed-text">Final submit in progress</span>
            ) : null}
          </p>
          <div>
            <p className="ft-12 black-text font-weight-500 mb-10">
              {fileStatus === FILE_UPLOAD_STATUS.ErrorCorrectionRequired ? (
                <>
                  {errorType === 2 ? (
                    <span>
                      <span className="error-text ft-14">
                        {duplicatesCount}
                      </span>{" "}
                      Duplicates found
                    </span>
                  ) : errorType === 3 ? (
                    <span>
                      Warnings{" "}
                      <span className="pending-text ft-14">{warnings}</span>{" "}
                      {""} | {""}
                      Errors <span className="error-text ft-14">{errors}</span>
                    </span>
                  ) : null}
                </>
              ) : null}
            </p>
          </div>
        </div>
      </div>

      <span
        className={
          fileStatus !== FILE_UPLOAD_STATUS.Cancelled &&
          fileStatus !== FILE_UPLOAD_STATUS.Completed &&
          fileStatus !== FILE_UPLOAD_STATUS.PayrollFundingInProgress &&
          fileStatus !== FILE_UPLOAD_STATUS.Deleted &&
          "vertical-line-var"
        }
      ></span>
      <div className={`d-flex  gradient${fileStatus}`} style={columns[5].style}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "50px",
            paddingBottom: "5%",
          }}
        >
          {/* <FontAwesomeIcon
              icon={faTrashAlt}
              size="13px"
              color="#FF0000"
              //onMouseOver={color="#FF0000"}
            /> */}
          {isAllowedDelete() &&
            fileStatus !== FILE_UPLOAD_STATUS.Cancelled &&
            fileStatus !== FILE_UPLOAD_STATUS.Completed &&
            fileStatus !== FILE_UPLOAD_STATUS.PayrollFundingInProgress &&
            fileStatus !== FILE_UPLOAD_STATUS.Deleted && (
              <div
                className="payroll-delete"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteSlider(true);
                }}
              >
                {/* <i
                className="fal fa-trash"
                onClick={() => onDeleteConfirmClick(data.id)}
              ></i> */}
                <FontAwesomeIcon icon={faTrashAlt} size="13px" />
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default FileStatusPayroll;
